module.exports = __webpack_public_path__ + "static/media/31-arrangement.85a02ac9.mp3";